/**
 * How finance cards name their records (`conversation-ui/entity-refs.ts`): a strategy as `def:<definition id>`, a
 * backtest as `run:<run id>`. The side panels and the detailed-view links take the bare ids.
 */
export function definitionIdOf(id: string): string {
  return id.startsWith('def:') ? id.slice('def:'.length) : id;
}

export function runIdOf(id: string): string {
  return id.startsWith('run:') ? id.slice('run:'.length) : id;
}
